(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('UserListController', UserListController);

    UserListController.$inject = ['$scope', '$rootScope', '$translate', '$sce', 'UserService', 'SystemConfigService', 'UserData'];

    function UserListController($scope, $rootScope, $translate, $sce, UserService, SystemConfigService, UserData) {
        var vm = this;
        vm.view = {};
        vm.view.tooltip = {
            systemConfig: '',
            editUser: '',
            deleteUser: ''
        };

        var modalInstance;

        vm.groupName = UserData.groupName;

        getTooltip();

        if (UserData.permissions.indexOf('userList') != -1) {
            UserService.getUserList().then(successList).catch(errorList);
        }
        var selectedUser = null;

        function getTooltip() {
            angular.forEach(vm.view.tooltip, translateTooltip);
        }

        var translateChangeListener = $rootScope.$on('$translateChangeSuccess', getTooltip);
        $rootScope.$on('$destroy', translateChangeListener);

        function translateTooltip(value, key, obj) {
            $translate('tooltip.' + key).then(function (translation) {
                vm.view.tooltip[key] = $sce.trustAsHtml(translation);
            });
        }

        vm.addUser = function () {
            UserService.addUserModalConstructor($scope);
        }

        vm.changePassword = function (id) {
            selectedUser = id;
            modalInstance = UserService.changePasswordModalConstructor(id, $scope);
        }

        vm.editUser = function (id) {
            selectedUser = id;
            UserService.editUserModalConstructor(id, $scope);
        }

        vm.deleteUser = function (user) {
            selectedUser = user.id;
            UserService.deleteUserModalConstructor(user, $scope);
        }

        vm.systemConfig = function () {
            SystemConfigService.systemConfigModalConstructor();
        }

        $scope.$on('userAddSuccess', successAdd);
        $scope.$on('userUpdateSuccess', successUpdate);
        $scope.$on('userEditCancel', function () {
            selectedUser = null;
        });
        $scope.$on('userDeleteSuccess', successDelete);
        $scope.$on('closeModalPassword', function () {
            modalInstance.dismiss('cancel')
        });

        function successList(data) {
            vm.userList = data;
        }

        function errorList(response) {
            UserService.errorModalConstructor(response, 'list');
        }

        function successDelete() {
            UserService.successModalConstructor('delete');
            vm.userList.forEach(function (item, index) {
                if (item.id == selectedUser) {
                    vm.userList.splice(index, 1);
                }
            });
            selectedUser = null;
        }

        function successAdd(event, addedUser) {
            vm.userList.push(addedUser);
        }

        function successUpdate(event, updatedUser) {
            UserService.successModalConstructor('save');
            vm.userList.forEach(function (user, index) {
                if (user.id == updatedUser.id) {
                    user.email = updatedUser.email;
                    user.groupId = updatedUser.groupId;
                    user.groupName = updatedUser.groupName;
                }
            });
        }
    }
})();